import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { LocaleContext } from 'app/containers/LocaleProvider';

import { validatePromocode } from 'app/utils/promocode.utils';
import formatPrice from 'app/utils/price';
import Snackbar from '../Snackbar';

import { locales } from './snackbarBasket.locales';

import './snackbar-basket.scss';


// const validatePromocodeOnNYpage = (args) => {
//     if (args?.uiState === 'error') {
//         return 'Не работает на новогоднее меню';
//     }

//     return args.label;
// };

const getText = ({
    isPromocodeApplied,
    successText,
    locale,
    promocodeConditions,
    pageId,
}) => {
    const { promoCodeApplyingErrorMessage } = promocodeConditions;

    if (promoCodeApplyingErrorMessage) {
        return promoCodeApplyingErrorMessage;
    }

    if (isPromocodeApplied) {
        return successText;
    }

    if (promocodeConditions) {
        const promocodeText = validatePromocode(
            promocodeConditions,
            true,
            locales[locale],
        );
        return promocodeText.label;
    }

    return locales[locale].errorIncorrectPromocode;
};


const SnackbarBasket = ({
    isLoading = false,
    isPromocodeApplied = true,
    isPromocodeCombineWithDiscount = true,
    successText: successTextProp = '',
    difference,
    onClickClose = null,
    promocodeConditions = null,
    pageId,
}) => {
    const { locale } = useContext(LocaleContext);

    const successText = successTextProp || locales[locale].successText;

    const canMakeOrder = difference <= 0;

    const promocodeText = getText({
        isPromocodeApplied,
        isPromocodeCombineWithDiscount,
        successText,
        locale,
        promocodeConditions,
        pageId,
    });

    return (
        <Snackbar
            shadowed
            angular
            onClickClose={onClickClose}
        >
            <div styleName="snackbar-content">
                <div styleName="snackbar-text">
                    {isLoading && '...'}
                    {!isLoading && canMakeOrder && promocodeText}
                    {!isLoading && !canMakeOrder && (
                        <>
                            {locales[locale].errorNeedMoreDishes}
                            &nbsp;
                            <span styleName="price">
                                {`${formatPrice(difference)} `}
                            </span>
                            <span styleName="price-ruble">
                                ₽
                            </span>
                        </>
                    )}
                </div>
            </div>
        </Snackbar>
    );
};

SnackbarBasket.propTypes = {
    isLoading: PropTypes.bool,
    isPromocodeApplied: PropTypes.bool,
    isPromocodeCombineWithDiscount: PropTypes.bool,
    successText: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
    onClickClose: PropTypes.func,
    difference: PropTypes.number.isRequired,
    promocodeConditions: PropTypes.shape({}),
};


export default SnackbarBasket;
